import { createReducer, createAction } from 'redux-act';
import Immutable from 'seamless-immutable';
import { createAsyncAction } from '../redux/action-util';
import { applyParamValues, setParamValue } from '../util';

const INITIAL_STATE = Immutable({
  emailReports: [],
  emailParams: null,
});

export const loadEmailReportsAction = createAsyncAction('loadEmailReports');
export const createEmailReportAction = createAsyncAction('createEmailReport');
export const deleteEmailReportAction = createAsyncAction('deleteEmailReport');
export const updateEmailReportAction = createAsyncAction('updateEmailReport');

export const loadEmailParamsAction = createAsyncAction('loadEmailParamsAction');
export const setEmailParamValueAction = createAction('setEmailParamValue');
export const resetEmailParamsAction = createAction('resetEmailParams');

const reducers = createReducer({
  [loadEmailReportsAction.DONE]: (state, emailReports) => state.merge({ emailReports }),
  [deleteEmailReportAction.DONE]: (state, emailReportId) => {
    const emailReports = state.emailReports.filter(r => r.scheduleId !== emailReportId);
    return state.merge({ emailReports });
  },
  [setEmailParamValueAction]: (state, { name, value }) => {
    const prevParams = state.emailParams || state.params;

    const params = setParamValue(prevParams, name, value);

    return state.merge({ emailParams: params });
  },
  [loadEmailParamsAction.INIT]: state => state.merge({ emailParams: [] }),
  [loadEmailParamsAction.DONE]: (state, newParams) => {
    const { data } = newParams;

    if (!data) {
      return state.merge({ params: INITIAL_STATE.emailParams });
    }

    const emailParams = applyParamValues(state.emailParams, data);

    return state.merge({ emailParams });
  },
  [resetEmailParamsAction]: state => state.merge({ emailParams: INITIAL_STATE.emailParams }),
}, INITIAL_STATE);

export default reducers;
